import { Club } from '../../shared/API/clubs/club.interface';
import { SET_CLUB } from './action-types';
import { ClubAction } from './club.interface';

export const setClub = (clubData: Club): ClubAction => ({
  type: SET_CLUB,
  payload: clubData,
});
